import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ADMIN_ROUTES, USER_ROUTES } from '../../constants/routeConstants';

const Unauthorized = () => {
  const { user } = useAuth();

  const dashboardPath =
    user?.role === 'super_admin'
      ? ADMIN_ROUTES.ADMIN_DASHBOARD
      : USER_ROUTES.USER_DASHBOARD;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <h1 className="text-3xl font-bold text-red-600 mb-4">Access Denied</h1>
        <p className="text-gray-600 mb-8">
          You don&apos;t have permission to access this page.
        </p>
        <Link
          to={dashboardPath}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default Unauthorized;
